import SearchContext from 'contexts/SearchContext';
import { pluralizePoiType } from 'data/pluralize';
import React, { useContext } from 'react';
import { Check, X } from 'react-feather';
import { Mixpanel } from 'utils/Mixpanel';

import PoiTypeIcon from '../../icons/PoiTypeIcon';
import FeaturedPoiTypeBadge from './FeaturedPoiTypeBadge';
import { setFilters, setPage } from 'contexts/SearchActions';
import HorizontalScroller from 'components/search/HorizontalScroller';

function PoiTypeFilters() {
    const { state, dispatch } = useContext(SearchContext);
    const availablePoiTypes = state.availableFilters.find((f) => f.slug === 'poi-type')?.options;
    const selectedFilters = state.filters;

    const poiTypeClicked = (poiType) => {
        const filter = {
            slug: 'poi-type',
            value: poiType.slug
        };

        Mixpanel.track('Search filters', {
            poiType: poiType.slug,
            view: state.mapView ? 'list' : 'map'
        });

        if (selectedFilters.find((f) => f.slug === filter.slug && f.value === filter.value)) {
            const updatedFilters = selectedFilters.filter((f) => f.slug === filter.slug && f.value !== filter.value);

            setPage(dispatch, 1);
            setFilters(dispatch, updatedFilters);
        } else {
            const updatedFilters = [filter, ...selectedFilters];
            setPage(dispatch, 1);
            setFilters(dispatch, updatedFilters);
        }
    };

    if (!availablePoiTypes || availablePoiTypes?.length === 0) return null;

    return (
        <HorizontalScroller>
            <div className="flex px-4">
                <div className="inline-flex gap-2 bg-gray-100 py-1 px-4 rounded-r-full rounded-l-full mx-auto">
                    {availablePoiTypes.map((pt) => {
                        const isSelected = selectedFilters.find((f) => f.slug === 'poi-type' && f.value === pt.slug);
                        return (
                            <button
                                key={pt.id}
                                className={`group border rounded-full flex items-center gap-1 py-1 px-2 text-sm outline-none focus:outline-none transition relative first:ml-auto last:mr-auto ${
                                    isSelected ? 'bg-white border-brand' : 'border-transparent  hover:border-black'
                                } ${pt.featured ? 'border-brand' : ''}`}
                                onClick={() => poiTypeClicked(pt)}
                            >
                                {pt.featured && <FeaturedPoiTypeBadge />}

                                {isSelected ? (
                                    <>
                                        <span className="group-hover:hidden">
                                            <Check width={18} height={17} />
                                        </span>
                                        <span className="hidden group-hover:block">
                                            <X width={18} height={17} />
                                        </span>
                                    </>
                                ) : (
                                    <PoiTypeIcon slug={pt.slug} size={18} />
                                )}

                                <span>{pluralizePoiType(pt.slug)}</span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </HorizontalScroller>
    );
}

export default PoiTypeFilters;
